import { constants, typographyStyles } from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";

const { textMObj, textXSObj } = typographyStyles;

const { colors } = constants;
const neutral400 = colors.ui.neutral[400];
const neutral600 = colors.ui.neutral[600];

export const formHeaderCss = {
  ...textXSObj,
  color: neutral400,
  textTransform: "uppercase",
  fontWeight: "bold",
  letterSpacing: "1px",
  margin: 0,
};

export const fieldsetCss = {
  border: 0,
  margin: 0,
  padding: 0,
};

export const legendCss = {
  ...textMObj,
  color: neutral600,
  padding: 0,
};

export const unorderedListCss = {
  display: "flex",
  flexDirection: "column",
  margin: "16px 0 0",
  padding: 0,
};

export const listCss = {
  listStyleType: "none",
  margin: "8px 0",
};

export const radioButtonCss = {
  alignItems: "flex-start",

  span: {
    margin: "3px 11px 3px 0",
  },

  "&:hover": {
    backgroundColor: greyDarkWithOpacity,
  },
};
